import React from 'react';
import { Box } from '@mui/material';
import { faFilePdf } from '@fortawesome/pro-light-svg-icons';
import { AppHeader } from '../../../components/app-header';
import { PageTitleZoneNext } from '../../../components/page-title-zone';
import { AttendanceStatisticsFilter } from './components/attendance-statistics-filter';
import { AttendanceStatisticsResult } from './components/attendance-statistics-result';
import { useCitizenContext } from '../../citizen/citizen-context-hooks';
import { AreaAside, AreaContainer, AreaContent, FloatingActionButton, FloatingActionButtonBar } from '../../../components/area-layout';
import { CitizenAttendanceStatisticsSummaryDto } from '../../../api-service/clients';
import { AttendanceStatisticsCourse, AttendanceStatisticsErrors, AttendanceStatisticsLesson, AttendanceStatisticsState } from './interfaces';
import { DatePickerValue } from '../../../components/date-picker';
import { useMetaTitle } from '../../../hooks';

interface IAttendanceStatisticsComponentProps {
  isLoading: boolean;
  isCourseScoped: boolean;
  courseName?: string;
  courses: AttendanceStatisticsCourse[];
  selectedCourses: AttendanceStatisticsCourse[];
  fromDate: DatePickerValue;
  toDate: DatePickerValue;
  includeFutureLessons: boolean;
  onAttendanceFilterChange: <K extends keyof AttendanceStatisticsState>(name: K, value: AttendanceStatisticsState[K]) => void;

  errors: AttendanceStatisticsErrors;

  onShowStatistics: () => void;

  summary?: CitizenAttendanceStatisticsSummaryDto;
  lessons?: AttendanceStatisticsLesson[];
  onReset: () => void;

  isGeneratingPdf: boolean;
  onCreatePdf?: () => void;
}

export function AttendanceStatisticsComponent(props: IAttendanceStatisticsComponentProps) {
  const {
    isLoading,
    isCourseScoped,
    courseName,
    courses,
    selectedCourses,
    fromDate,
    toDate,
    includeFutureLessons,
    onAttendanceFilterChange,
    errors,
    onShowStatistics,
    lessons,
    summary,
    onReset,
    onCreatePdf,
    isGeneratingPdf,
  } = props;
  const { fullName } = useCitizenContext();
  const subtitle = isCourseScoped ? courseName : fullName;
  useMetaTitle(subtitle ? `Fremmødestatistik - ${subtitle}` : 'Fremmødestatistik');

  return (
    <Box>
      <AppHeader />
      <PageTitleZoneNext entityName="Fremmødestatistik" title="Fremmødestatistik" subtitle={subtitle} />
      <AreaContainer>
        <AreaContent>
          <AttendanceStatisticsFilter
            courses={courses}
            selectedCourses={selectedCourses}
            fromDate={fromDate}
            toDate={toDate}
            onAttendanceFilterChange={onAttendanceFilterChange}
            errors={errors}
            onShowStatistics={onShowStatistics}
            onReset={onReset}
            isLoading={isLoading}
            includeFutureLessons={includeFutureLessons}
            showCourseFilter={!isCourseScoped}
          />
          <AttendanceStatisticsResult lessons={lessons} summary={summary} showLessonDetails={!isCourseScoped} />
        </AreaContent>
        <AreaAside>
          <FloatingActionButtonBar>
            {onCreatePdf && <FloatingActionButton buttonText="Dan PDF" icon={faFilePdf} onClick={onCreatePdf} loading={isGeneratingPdf} />}
          </FloatingActionButtonBar>
        </AreaAside>
      </AreaContainer>
    </Box>
  );
}
